import { Injectable } from '@angular/core';
import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { LocalStorageService } from './local-storage.service';
import { Router } from '@angular/router';
import { logout } from '../../ngrx/actions/user.actions';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private axiosInstance: AxiosInstance;

  constructor(
    private store: Store,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {
    this.axiosInstance = axios.create({
      baseURL: environment.apiUrl,
    });
    this.axiosInstance.interceptors.request.use(this.handleRequest.bind(this));
    this.axiosInstance.interceptors.response.use(
      this.handleResponse.bind(this),
      this.handleError.bind(this)
    );
  }

  private handleRequest(request: InternalAxiosRequestConfig<any>) {
    const userToken = JSON.parse(this.localStorageService.getItem('tokenInfo') ?? "{}").token;
    if (userToken) {
      request.headers.Authorization = `Bearer ${userToken}`;
    }
    return request;
  }

  private handleResponse(response: AxiosResponse<any>) {
    return response;
  }

  private async handleError(error: any) {
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized request, redirecting to login.');
      this.store.dispatch(logout())
    }
    return Promise.reject(error);
  }

  get<T>(url: string, params?: any): Promise<AxiosResponse<T, any>> {
    return this.axiosInstance.get<T>(url, { params });
  }

  post<T>(url: string, data: any): Promise<AxiosResponse<T, any>> {
    return this.axiosInstance.post<T>(url, data);
  }

  put<T>(url: string, data: any): Promise<AxiosResponse<T, any>> {
    return this.axiosInstance.put<T>(url, data);
  }

  patch<T>(url: string, data: any): Promise<AxiosResponse<T, any>> {
    return this.axiosInstance.patch<T>(url, data);
  }

  delete<T>(url: string): Promise<AxiosResponse<T, any>> {
    return this.axiosInstance.delete<T>(url);
  }
}
